"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ExternalApiQueryMpiPortfolio_1 = require("./ExternalApiQueryMpiPortfolio");

var ProviderBase_1 = require("../ProviderBase");

var MpiProvider =
/** @class */
function (_super) {
  __extends(MpiProvider, _super);

  function MpiProvider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getQuery = function (queryOptions, translationHelper) {
      var query;
      var name = _this.request.name;

      if (name === 'portfolio') {
        query = new ExternalApiQueryMpiPortfolio_1.ExternalApiQueryMpiPortfolio(queryOptions, translationHelper);
      }

      return query;
    };

    return _this;
  }

  return MpiProvider;
}(ProviderBase_1.ProviderBase);

exports.MpiProvider = MpiProvider;